<template>
  <div
    class="square-button outer "
    :class="isSub ? 'sub' : 'main'"
    @click.stop="handleSquareBtnClick"
  >
    <v-btn class="inner" :class="{max_width: isMaxWidth, small: isSmall, inversion: inversion}">
      <span class="text">{{ text }}</span>
    </v-btn>
  </div>
</template>

<script>
export default {
  name: 'SquareButton',

  props: {
    isSub: {
      type: Boolean,
      default: false,
    },
    isSmall: {
      type: Boolean,
      default: false,
    },
    inversion: {
      type: Boolean,
      default: false,
    },
    text: {
      type: String,
    },
    isMaxWidth: {
      type: Boolean,
      default: false,
    },
  },

  methods: {
    handleSquareBtnClick() {
      this.$emit('handleSquareBtnClick');
    },
  },
};
</script>

<style lang="scss" scoped>
.square-button{
  padding: 2px;
  border-radius: 4px;
  .v-btn.inner{
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
    height: 100%;
    padding: 10px;
    box-shadow: 0 6px 15px rgba(0, 0, 0, 0.25), 0 0 0 2px rgba(255, 255, 255, 0.9) inset;
    border-radius: 100px;
    background-color: #ffffff !important;
    .text{
      font-family: $notoSans;
      color: $mainColor;
      text-transform: initial;
      font-size: 16px;
      font-weight: bold;
    }
  }
  &.sub{
    .v-btn.inner {
      border: solid 1px $gray;
      .text {
        color: $gray;
        font-weight: bold;
      }
    }
  }
  .v-btn.max_width {
    max-width: 240px;
  }
  .v-btn.small {
    .text {
      font-size: 80%;
      padding: 0 10px;
    }
  }
  .v-btn.inversion {
    background-color: rgba(0, 0, 0, 0)!important;
    border: solid 1px $white!important;
    span {
      color: $white!important;
    }
  }
}
</style>
